var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeQuarterTo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,12A12,12,0,0,1,0,12c0-.367.017-.731.049-1.09l1.992.181Q2,11.54,2,12A10,10,0,1,0,12,2q-.46,0-.909.041L10.91.049C11.269.017,11.633,0,12,0A12.013,12.013,0,0,1,24,12ZM5.663,4.263,4.395,2.717A12.125,12.125,0,0,0,2.715,4.4L4.262,5.665A10.144,10.144,0,0,1,5.663,4.263ZM9.142,2.415,8.571.5a11.984,11.984,0,0,0-2.2.9l.939,1.766A9.951,9.951,0,0,1,9.142,2.415Zm-5.978,4.9L1.4,6.375a12.013,12.013,0,0,0-.9,2.2l1.917.571A9.964,9.964,0,0,1,3.164,7.313ZM11,6v4.277a2,2,0,0,0-.723.723H7v2h3.277A1.994,1.994,0,1,0,13,10.277V6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeQuarterTo);
export default __webpack_public_path__ + "static/media/time-quarter-to.54812a3f7c2569f12cb317c78e52bf57.svg";
export { ForwardRef as ReactComponent };